import { OnboardingState } from './state';

export const resetOnboarding = (): OnboardingState['onboarding'] => ({
  id: '',
  userId: '',
  artist: {
    id: '',
    name: '',
    avatar: '',
    shortId: '',
    type: 'solo',
    created_at: new Date(),
    updated_at: new Date(),
  },
  plan: '',
  paymentRequired: true,
});

export const onboardingInitialState: OnboardingState = {
  inProgress: false,
  onboarding: resetOnboarding(),
};
